
/**
 * Variants. Export as a single variants object.
 */
import { buttonVariants } from './controls/index'

export const variants = {
  button: buttonVariants
}

/**
 * Utility
 */
export { GlobalStyle } from './globalStyle'
export {
  theme, tokens, mixins, utils
} from './theme/index'
export {
  withSx
} from './utils'

/**
 * Layout
 */
export {
  Box, Flex, Aspect, Spread,
  Screen, View, Pane,
  Divider, Spacer, XO,
  Image, RawImage, Card,
  Placeholder
} from './layout/index'

/**
 * Type
 */
export {
  Text, Markdown, Badge,
  H1, H2, H3, H4, H5, H6, P, Blockquote,
  Code, Pre, CodeBlock,
  List, ListItem, Link
} from './type/index'

/**
 * Controls
 */
export {
  Button, ButtonGroup,
  Checkbox, Label, Input,
  Range, Select
} from './controls/index'

/**
 * Icons
 */
export {
  Icon, getIcon
} from './icons/index'
